import { NovaWard } from '../systems/combat/weapons/fusions/NovaWard.js';
import { StormLance } from '../systems/combat/weapons/fusions/StormLance.js';
import { Cannonade } from '../systems/combat/weapons/fusions/Cannonade.js';
import { StaticBloom } from '../systems/combat/weapons/fusions/StaticBloom.js';
import { Shatterpoint } from '../systems/combat/weapons/fusions/Shatterpoint.js';
import { Halo } from '../systems/combat/weapons/fusions/Halo.js';
import { LumenLance } from '../systems/combat/weapons/fusions/LumenLance.js';
import { Rubric } from '../systems/combat/weapons/fusions/Rubric.js';
import { Antiphon } from '../systems/combat/weapons/fusions/Antiphon.js';

/**
 * Harmonics: when both parents are owned at their max level (8), the fusion
 * becomes offerable as a level-up card (ProgressionSystem._buildChoices).
 * Accepting it removes BOTH parents and adds the fused weapon at level 1 of
 * its own 5-level ladder (CombatSystem.fuseWeapons) — freeing a weapon slot
 * and relieving the distinct-name damage soft-cap in the same move.
 *
 * 9 of the 36 possible pairs across the now-9 base weapons are curated; the
 * rest are future content, not a data gap. The last five are Act II's and Act
 * III's (ACT2-BIBLE.md §7, ACT3-BIBLE.md §7) — each pairs a new weapon with an
 * existing one, so the new weapons multiply the fusion table rather than
 * sitting beside it. Act III's two are here for the same reason Act II's are:
 * without a recipe, a Quill or Fugue starter is a weapon that can never leave
 * the distinct-name damage soft-cap.
 */
export const FUSION_DEFS = [
  {
    id: 'novaWard',
    name: 'Nova Ward',
    parents: ['Nova Pulse', 'Orbit Ward'],
    description: 'Orbiting shards that each bloom a micro-pulse in turn.',
    create: () => new NovaWard(),
  },
  {
    id: 'stormLance',
    name: 'Storm Lance',
    parents: ['Spirit Lance', 'Arc Needle'],
    description: 'A piercing lance that sheds homing needles in its wake.',
    create: () => new StormLance(),
  },
  {
    id: 'cannonade',
    name: 'Cannonade',
    parents: ['Scatter Cannon', 'Spirit Lance'],
    description: 'Pellet volleys, with every third shot a piercing slug.',
    create: () => new Cannonade(),
  },
  {
    id: 'staticBloom',
    name: 'Static Bloom',
    parents: ['Nova Pulse', 'Arc Needle'],
    description: 'Each pulse launches homing needles from its rim.',
    create: () => new StaticBloom(),
  },
  {
    id: 'shatterpoint',
    name: 'Shatterpoint',
    parents: ['Resonor', 'Nova Pulse'],
    description: 'One heavy blast, saved up and spent at once.',
    create: () => new Shatterpoint(),
  },
  {
    id: 'halo',
    name: 'Halo',
    parents: ['Umbral Lantern', 'Orbit Ward'],
    description: 'An orbiting ring of light that clips bullets and lights the dark.',
    create: () => new Halo(),
  },
  {
    id: 'lumenLance',
    name: 'Lumen Lance',
    parents: ['Umbral Lantern', 'Spirit Lance'],
    description: 'A piercing bolt of lantern-light — see the dark from range.',
    create: () => new LumenLance(),
  },
  {
    id: 'rubric',
    name: 'Rubric',
    parents: ['Glyphpen', 'Nova Pulse'],
    description: 'Written marks that burn where they lie instead of fading.',
    create: () => new Rubric(),
  },
  {
    id: 'antiphon',
    name: 'Antiphon',
    parents: ['Countersong', 'Arc Needle'],
    description: 'The arc answers in homing needles, and turns fire around faster.',
    create: () => new Antiphon(),
  },
];
